import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Download = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        stroke="#344054"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M9.901 12.325V2.291M12.329 9.887l-2.43 2.44-2.43-2.44" />
        <path d="M13.643 6.049c2.982.275 4.067 1.391 4.067 5.833C17.71 17.8 15.784 17.8 10 17.8c-5.784 0-7.708 0-7.708-5.917 0-4.442 1.083-5.558 4.067-5.833" />
      </g>
    </svg>
  );
};
export default Download;
